import { GlLink, GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import { TRACKING_ACTION_COPY_NUGET_INSTALL_COMMAND, TRACKING_ACTION_COPY_NUGET_SETUP_COMMAND, TRACKING_LABEL_CODE_INSTRUCTION, NUGET_HELP_PATH } from '~/packages_and_registries/package_registry/constants';
import CodeInstruction from '~/vue_shared/components/registry/code_instruction.vue';
export default {
    name: 'NugetInstallation',
    components: {
        CodeInstruction,
        GlLink,
        GlSprintf
    },
    props: {
        packageEntity: {
            type: Object,
            required: true
        }
    },
    computed: {
        nugetInstallationCommand () {
            return `nuget install ${this.packageEntity.name} -Source "GitLab"`;
        },
        nugetSetupCommand () {
            return `nuget source Add -Name "GitLab" -Source "${this.packageEntity.nugetUrl}" -UserName <your_username> -Password <your_token>`;
        }
    },
    tracking: {
        TRACKING_ACTION_COPY_NUGET_INSTALL_COMMAND,
        TRACKING_ACTION_COPY_NUGET_SETUP_COMMAND,
        TRACKING_LABEL_CODE_INSTRUCTION
    },
    i18n: {
        helpText: s__('PackageRegistry|For more information on the NuGet registry, %{linkStart}see the documentation%{linkEnd}.')
    },
    links: {
        NUGET_HELP_PATH
    }
};
